<template>
  <div class="MemberRights">
    <ComTitlte titleEn=" MEMBER RIGHTS" titleZh="会员权益"></ComTitlte>
    <div class="rightsList">
      <div class="item_rights">
        <i class="i_icon i_icon1"></i>
        <span class="i_lable">政策解读</span>
      </div>
      <div class="item_rights">
        <i class="i_icon i_icon2"></i>
        <span class="i_lable">评价、评审、推荐</span>
      </div>
      <div class="item_rights">
        <i class="i_icon i_icon3"></i>
        <span class="i_lable">产学研对接</span>
      </div>
      <div class="item_rights">
        <i class="i_icon i_icon4"></i>
        <span class="i_lable">咨询、交流、培训</span>
      </div>
      <div class="item_rights">
        <i class="i_icon i_icon5"></i>
        <span class="i_lable">精益生产</span>
      </div>
      <div class="item_rights">
        <i class="i_icon i_icon6"></i>
        <span class="i_lable">法律顾问</span>
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "MemberRights",
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
.MemberRights {
  position: relative;
  .rightsList {
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    margin: 20px 0 0 0;
    border: solid 1px #e5e5e5;
    .item_rights {
      flex: 1;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 1px;
        height: 50px;
        background-color: #e5e5e5;
        position: absolute;
        top: 10px;
        right: 0;
      }
      &:last-child::before {
        display: none;
      }
      .i_icon {
        display: block;
        width: 50px;
        height: 50px;
        // border-radius: 50%;
        // background-color: #003b99;
        margin: 0 auto 20px;
        &.i_icon1 {
          background: url("../../../assets/img/company/icon_rights_1.png")
            center no-repeat;
          background-size: contain;
        }
        &.i_icon2 {
          background: url("../../../assets/img/company/icon_rights_2.png")
            center no-repeat;
          background-size: contain;
        }
        &.i_icon3 {
          background: url("../../../assets/img/company/icon_rights_3.png")
            center no-repeat;
          background-size: contain;
        }
        &.i_icon4 {
          background: url("../../../assets/img/company/icon_rights_4.png")
            center no-repeat;
          background-size: contain;
        }
        &.i_icon5 {
          background: url("../../../assets/img/company/icon_rights_5.png")
            center no-repeat;
          background-size: contain;
        }
        &.i_icon6 {
          background: url("../../../assets/img/company/icon_rights_6.png")
            center no-repeat;
          background-size: contain;
        }
      }
      .i_lable {
        display: block;
        font-size: 16px;
        line-height: 30px;
        color: #333333;
        margin: 0 auto;
        text-align: center;
      }
    }
  }
}
</style>
